import { useScanner } from "@blackfisk/vue/composables/useScanner";
import LogRocket from "logrocket";
import { storeToRefs } from "pinia";
import { watch } from "vue";
import { useRouter } from "vue-router";

import { useIdentityStore } from "@/stores/identity";

export const useLogRocket = (): void => {
  if (import.meta.env.VITE_ENVIRONMENT !== "local") {
    const router = useRouter();
    // * Identify User to LogRocket on account switch
    const IdentityStore = useIdentityStore();
    const { userId, userName, userEmail, activeAccount } = storeToRefs(IdentityStore);
    const identifyUser = (): void => {
      if (userId.value > 0) {
        LogRocket.identify(`${userId.value}`, {
          id: userId.value,
          name: userName.value,
          email: userEmail.value,
          accountId: activeAccount.value?.id ?? 0,
          accountName: activeAccount.value?.name ?? "",
        });
      }
    };
    watch(userEmail, () => {
      if (userEmail.value) {
        identifyUser();
      }
    });
    // * Re-identify on account switch so the replay carries the active account.
    watch(activeAccount, () => {
      identifyUser();
    });
    // * Track Scans
    const { latestScan } = useScanner();
    watch(latestScan, () => {
      if (latestScan.value) {
        LogRocket.track("BARCODE_SCAN", {
          type: latestScan.value.type,
          subtype: latestScan.value.subtype,
          ...(latestScan.value.meta !== undefined
            ? { meta: JSON.stringify(latestScan.value.meta) }
            : {}),
        });
      }
    });
    // * Identify User to LogRocket on route change
    router.beforeEach((to, from) => {
      if (userId.value > 0 && to.path !== from.path) {
        identifyUser();
      }
    });
    // * Mark the replay with the route the user is on (searchable in LogRocket).
    router.afterEach((to) => {
      LogRocket.track("ROUTE_CHANGE", {
        path: to.path,
        name: String(to.name ?? ""),
      });
    });
  }
};
